import accounts from './accounts.json'
import addAccounts from './add-accounts.json'
import analytics from './analytics.json'
import antiban from './antiban.json'
import apiInfo from './api-info.json'
import app from './app.json'
import audiences from './audiences.json'
import auth from './auth.json'
import balance from './balance.json'
import budget from './budget.json'
import common from './common.json'
import createProfile from './create-profile.json'
import documents from './documents.json'
import financialTerms from './financial-terms.json'
import history from './history.json'
import invoices from './invoices.json'
import menu from './menu.json'
import notifications from './notifications.json'
import paymentMethod from './payment-method.json'
import refferal from './refferal.json'
import settings from './settings.json'

export default {
  ...app,
  ...apiInfo,
  ...common,
  ...financialTerms,
  ...accounts,
  ...addAccounts,
  ...antiban,
  ...analytics,
  ...balance,
  ...budget,
  ...documents,
  ...createProfile,
  ...auth,
  ...refferal,
  ...invoices,
  ...history,
  ...menu,
  ...notifications,
  ...settings,
  ...paymentMethod,
  ...audiences,
}
